import { mcGetItem, mcSetItem, mcSetCloudItem, getMcRemovedProfileIds } from "./mcCloudSync";

export const MC_PEOPLE_KEY = "mc-response-people";
export const MC_PEOPLE_EVENT = "mc-response-people-event";

function safeParse(raw, fallback) {
  try { return raw ? JSON.parse(raw) : fallback; } catch (_) { return fallback; }
}

function clean(value = "") { return String(value ?? "").trim(); }

export function normalizePerson(person = {}) {
  const now = new Date().toISOString();
  return {
    id: person.id || `person-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    fullName: clean(person.fullName),
    role: clean(person.role) || "Manager",
    email: clean(person.email).toLowerCase(),
    whatsapp: clean(person.whatsapp),
    active: person.active !== false,
    createdAt: person.createdAt || now,
    updatedAt: now,
  };
}

export function loadPeople() {
  const parsed = safeParse(mcGetItem(MC_PEOPLE_KEY), []);
  const removed = getMcRemovedProfileIds();
  return Array.isArray(parsed) ? parsed.filter((person) => person && !removed.has(person.id)).map(normalizePerson) : [];
}

function persistPeopleToCloud(payload, attempt = 0) {
  try {
    mcSetCloudItem(MC_PEOPLE_KEY, payload).then((saved) => {
      if (!saved && attempt < 4 && typeof window !== "undefined") {
        window.setTimeout(() => persistPeopleToCloud(payload, attempt + 1), 750 * (attempt + 1));
      }
    }).catch(() => {
      if (attempt < 4 && typeof window !== "undefined") {
        window.setTimeout(() => persistPeopleToCloud(payload, attempt + 1), 750 * (attempt + 1));
      }
    });
  } catch (_) {
    if (attempt < 4 && typeof window !== "undefined") {
      window.setTimeout(() => persistPeopleToCloud(payload, attempt + 1), 750 * (attempt + 1));
    }
  }
}

export function savePeople(people = []) {
  const normalized = (Array.isArray(people) ? people : []).map(normalizePerson);
  const payload = JSON.stringify(normalized);
  mcSetItem(MC_PEOPLE_KEY, payload);
  persistPeopleToCloud(payload);
  try { window.dispatchEvent(new CustomEvent(MC_PEOPLE_EVENT)); } catch (_) {}
  return normalized;
}

export function findPerson(personId = "") {
  return loadPeople().find((person) => person.id === personId) || null;
}
